import { ChatThreadProps } from './ChatThread.types';
import { Fragment, memo, useRef } from 'react';
import { ChatMessage } from '../ChatMessage';

interface OptimizedChatThreadProps extends Omit<ChatThreadProps, 'scrollRef' | 'waiting'> {
  typewriter?: boolean;
}

/**
 * The 20px mask at both ends fades messages into the scroll edges instead of
 * clipping them, so `scrollbar-gutter: stable` is what keeps the column from
 * shifting sideways when the scrollbar appears.
 */
const CONTAINER_CLASSES =
  'relative mx-auto mb-4 flex w-full max-w-175 justify-center pb-8 pl-4 pr-4 [scrollbar-gutter:stable] [mask-image:linear-gradient(to_bottom,transparent_0%,black_20px,black_calc(100%-20px),transparent_100%)]';

export const ChatThread = memo<OptimizedChatThreadProps>(
  ({ messages, typewriter = true, footer, renderAfterMessage }) => {
    const scrollTargetRef = useRef<HTMLDivElement>(null);

    return (
      <div className={CONTAINER_CLASSES}>
        <div className="max-w-175 w-full">
          {messages.map((msg, index) => (
            <Fragment key={msg.messageId}>
              <ChatMessage
                msg={msg}
                typewriter={typewriter}
                agentId={'agentId' in msg ? msg.agentId : undefined}
                isLastMessage={msg.type === 'agent' && msg.isLastMessage ? true : false}
              />
              {renderAfterMessage?.(index)}
            </Fragment>
          ))}
          {footer}
          <div data-testid="scroll-target" ref={scrollTargetRef} />
        </div>
      </div>
    );
  },
);

ChatThread.displayName = 'ChatThread';
